import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2b11500a")

_pushScopeId("data-v-2b11500a")
const _hoisted_1 = { class: "service-list-item-image" }
const _hoisted_2 = {
  key: 1,
  class: "service-list-item-image-no-image",
  src: _imports_0
}
const _hoisted_3 = { class: "service-list-item-right-area" }
const _hoisted_4 = { class: "service-list-item-text-flex" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "service-list-item-divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "service-list-item-area",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
    }, [
      _createVNode("div", _hoisted_1, [
        (_ctx.imageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "service-list-item-image-icon",
              src: _ctx.imageUrl,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onError(...args)))
            }, null, 40, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_2))
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createVNode("div", {
          innerHTML: _ctx.description,
          class: "service-list-item-text-flex-message"
        }, null, 8, ["innerHTML"])
      ])
    ]),
    _hoisted_5
  ], 64 /* STABLE_FRAGMENT */))
})